const lg = document.querySelector('.c-product-gallery-popup');

if (lg) {

    function setupMagnifier() {
        const existingMagnifier = document.querySelector('.magnifier');
        if (existingMagnifier) {
            existingMagnifier.remove();
        }

        const currentSlide = document.querySelector('.lg-current');
        if (!currentSlide) return;

        const lgContainer = currentSlide.querySelector('.lg-img-wrap');
        if (!lgContainer) return;

        let magnifier = document.createElement('div');
        magnifier.className = 'magnifier';
        magnifier.style.display = 'none';

        let magnifierImg = document.createElement('img');
        magnifierImg.className = 'magnifier-img';
        magnifier.appendChild(magnifierImg);

        lgContainer.appendChild(magnifier);

    }

    lg.addEventListener('lgAfterOpen', function () {
        setTimeout(setupMagnifier, 100);
    });

    lg.addEventListener('lgAfterSlide', function () {
        setTimeout(setupMagnifier, 100);
    });

    document.addEventListener('mousemove', function (e) {

        const magnifier = document.querySelector('.magnifier');
        const magnifierImg = document.querySelector('.magnifier-img');
        if (!magnifier || !magnifierImg) return;

        const currentImg = document.querySelector('.lg-current .lg-image');
        if (!currentImg) return;

        const rect = currentImg.getBoundingClientRect();

        if (
            e.clientX >= rect.left &&
            e.clientX <= rect.right &&
            e.clientY >= rect.top &&
            e.clientY <= rect.bottom
        ) {
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;

            magnifier.style.display = 'block';
            magnifier.style.left = e.clientX + 'px';
            magnifier.style.top = e.clientY + 'px';

            magnifierImg.src = currentImg.src;

            const zoomFactor = 2;
            magnifierImg.style.width = rect.width * zoomFactor + 'px';
            magnifierImg.style.height = rect.height * zoomFactor + 'px';

            const relativeX = x / rect.width;
            const relativeY = y / rect.height;

            const magnifierWidth = magnifier.offsetWidth;
            const magnifierHeight = magnifier.offsetHeight;

            const imgX = (relativeX * rect.width * zoomFactor) - (magnifierWidth / 2);
            const imgY = (relativeY * rect.height * zoomFactor) - (magnifierHeight / 2);

            magnifierImg.style.left = -imgX + 'px';
            magnifierImg.style.top = -imgY + 'px';
        } else {
            magnifier.style.display = 'none';
        }
    });

    lg.addEventListener('lgBeforeClose', function () {
        const magnifier = document.querySelector('.magnifier');
        if (magnifier) {
            magnifier.remove();
        }

        const style = document.getElementById('magnifier-cursor-style');
        if (style) {
            style.remove();
        }
    });
}